<template>
    <div class="main-background">
      <v-card class="ma-4" max-width="800px" min-width="300px" height="auto">
        <v-card-title class="text-h6">Profil de l'utilisateur :</v-card-title>
        <v-card-text>
          <p>{{ user.email }}</p>
        </v-card-text>
  
        <v-card-actions class="d-flex flex-wrap">
          <v-btn class="mx-2" @click="editEmail">Modifier l'email</v-btn>
          <v-btn class="mx-2" @click="editPassword">Modifier le mot de passe</v-btn>
          <v-btn class="mx-2" style="color:darkred" @click="deleteAccount">Supprimer mon compte</v-btn>
        </v-card-actions>
  
        <update-email-dialog v-if="showEmailForm" @close="showEmailForm = false" />
        <update-password-dialog v-if="showPasswordForm" @close="showPasswordForm = false" />
        <delete-account-dialog v-if="showDeleteAccountForm" @close="showDeleteAccountForm = false" />
      </v-card>
    </div>
  </template>
  
  <script setup>
  import { ref } from 'vue';
  import { useAuthStore } from '@/store/AuthStore';
  import UpdateEmailDialog from './UpdateEmailDialog.vue';
  import UpdatePasswordDialog from './UpdatePasswordDialog.vue';
  import DeleteAccountDialog from './DeleteAccountDialog.vue';
  
  const authStore = useAuthStore();
  const user = authStore.user;
  const showEmailForm = ref(false);
  const showPasswordForm = ref(false);
  const showDeleteAccountForm = ref(false);
  
  const editEmail = () => {
    showEmailForm.value = true;
  };
  
  const editPassword = () => {
    showPasswordForm.value = true;
  };
  
  const deleteAccount = () => {
    showDeleteAccountForm.value = true;
  };
  </script>